import cn from 'bem-cn';

import { Stack } from '../../components/UI';
import { Feed } from '../../components/Feed';
import { usePromptFeedColumns } from '../HomePage/HomePage.hooks';
import { useInfiniteScroll } from '../../hooks/useInfiniteScroll';

import { useSearchResults } from './SearchPage.hooks';
import { PAGES_COUNT, ROWS_COUNT } from './SearchPage.constants';
import './SearchPage.scss';

const b = cn('search-page');

export const SearchPage = () => {
    const columns = usePromptFeedColumns();
    const size = columns * ROWS_COUNT * PAGES_COUNT;

    const { data, isLoading, loadMore, hasMore } = useSearchResults(size);

    useInfiniteScroll(loadMore, { loading: isLoading, hasMore, threshold: 700 });

    return (
        <Stack className={b()}>
            <Stack spacing={32} className={b('content')}>
                <Stack spacing={12} className={b('text-block')}>
                    <h1>ДАВАЙТЕ СМОТРЕТЬ</h1>
                    <p>Подборка промптов, курсов и ИИ-челленджей по вашему запросу, собранная нейросетями</p>
                </Stack>
                <Stack>
                    <Feed isLoading={isLoading} prompts={data} columns={columns} hasMore={hasMore} />
                </Stack>
            </Stack>
        </Stack>
    );
};
